import React from "react";
import { isEmpty } from "lodash-es";

/**
 * Inline validation messages for a single form field.
 *
 * @param {{ id: string, messages?: string[] }} props
 */
export default function FormError({ id, messages }) {
  if (isEmpty(messages)) {
    return null;
  }

  return (
    <p id={id} className="form-row__error" role="alert">
      {messages.join(" ")}
    </p>
  );
}
